import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function ProtectedRoute({ children }) {
  const { isAuthed, ready } = useAuth();
  const loc = useLocation();
  if (!ready) return <div style={{ padding: 40, textAlign: 'center', color: 'var(--muted)' }}>…</div>;
  if (!isAuthed) return <Navigate to="/login" replace state={{ from: loc }} />;
  return children;
}
